import { getCandidatesEntities } from '@collections/candidates';
import { hasAnonymization } from '@collections/users';
import { createSelector } from '@ngrx/store';
import { CandidateAdapter, Candidate } from '@shared';
import { Pagination, PaginationAdapter } from '@shared/pagination';

import { CandidatesPageState, getCandidatesPageState } from './candidates.reducer';

export const getCandidatesPageCandidatesState = createSelector(
  getCandidatesPageState,
  (state: CandidatesPageState) => !!state && state.candidates,
);
export const getCandidatesPageCandidatesNumber = createSelector(
  getCandidatesPageCandidatesState,
  (pagination: Pagination) => (!!pagination && !!pagination.number ? pagination.number : undefined),
);
export const getCandidatesTotal = createSelector(
  getCandidatesPageCandidatesState,
  (pagination: Pagination) => pagination?.totalElements || 0,
);
export const getCandidatesPageCandidatesIds = createSelector(
  getCandidatesPageCandidatesState,
  (pagination: Pagination) => !!pagination && new PaginationAdapter(pagination).contentIds,
);
export const getCandidatesPageCandidates = createSelector(
  getCandidatesPageCandidatesIds,
  getCandidatesEntities,
  hasAnonymization,
  (ids, entities, anonymization: boolean, props) =>
    !!ids &&
    ids.map(
      (id: number) =>
        new CandidateAdapter(entities[id], !!props && !!props.anonymize && !!anonymization),
    ),
);

export const getCandidatesJobsState = createSelector(
  getCandidatesPageState,
  (state: CandidatesPageState) => !!state && state.jobs,
);
export const getJobFeaturedCandidate = createSelector(
  getCandidatesJobsState,
  (jobs) => !!jobs && jobs.content,
);

export const getCandidateById = createSelector(
  getCandidatesEntities,
  (entities, { id }) => !!entities && !!id && entities[id],
);

const getSimilarCandidatesState = createSelector(
  getCandidatesPageState,
  (state: CandidatesPageState) => !!state && state.similar,
);

const getSimilarCandidatesIds = createSelector(
  getSimilarCandidatesState,
  (pagination: Pagination) => !!pagination && new PaginationAdapter(pagination).contentIds,
);

const getSimilarCandidateEntities = createSelector(
  getSimilarCandidatesIds,
  getCandidatesEntities,
  (similarCandidateIds, allCandidatesEntities) =>
    !!similarCandidateIds && similarCandidateIds.map((id) => allCandidatesEntities[id]),
);

export const SimilarCandidatesObj = {
  getSimilarCandidates: (anonymize?: boolean) =>
    createSelector(
      getSimilarCandidateEntities,
      hasAnonymization,
      (similarCandidatesEntities, hasAnonymization: boolean) =>
        !!similarCandidatesEntities &&
        similarCandidatesEntities.map(
          (candidate: Candidate) =>
            new CandidateAdapter(candidate, !!anonymize && !!hasAnonymization),
        ),
    ),
};
